// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import mapSeries from 'async/mapSeries';

import XDialog from './XDialog.jsx';
import Wait from './Wait.jsx';
import Stats from './Stats.jsx';
import MenuCulti from './MenuCulti.jsx';
import MenuStats from './MenuStats.jsx';
import TablaOportUPL from './TablaOportUPL.jsx';
import {MapButton, MapIcon} from './MapButtons.jsx';
import App from './App.jsx';
import SelectCulti from './SelectCulti.jsx';

import Role from './roles.js';
import show_stats from './show_stats.js';
import {load_stats} from './show_stats.js';
import {takeCod, highest_shps, has_low_priority, T_CULTI, T_MAV} from './codtype.js';

import {takeDir, takeFilename, title_culti, show_path, mav_rows, noop, es_mapa_tematico, gen_snum, abrev, unFuck} from './utils.js';
import {get_area_extent, get_mapatematico_fathers} from './fetch_things.js';

import type {T_Kind} from './codtype.js';
import type {T_Next, T_ErrNum} from './types.js';
import type {T_Stats} from './Stats.jsx';

import './css/Toolbar.css';



type T_ToolbarProps = {
  cultis         : Array<string>,
  current_map    : ?string,
  window_drag    : boolean,
  show_tree      : boolean,
  width          : number,
  num_decimals   : number,
  configuring_doc: boolean,
  app            : App
};



export type T_SelPol = {
  path: string,
  id  : number
};



type T_ToolbarState = {
  sel_pol          : ?T_SelPol,
	sel_pol_cf			 : ?Array<T_SelPol>,
  stats            : ?T_Stats,
  stats_recalc     : boolean,
  culti            : string,      // FIXME culti puede ser undefined!
  cod              : T_Kind,
  use_tools        : boolean,
  show_menu_culti  : boolean,
  show_menu_stats  : boolean,
  show_tabla_oport : boolean,
  show_select_culti: boolean,
  ordered_pairs    : ?Array<{elem: string, png_path: string}>,
  hay_rasters      : boolean
};



export default class Toolbar extends Component<T_ToolbarProps, T_ToolbarState> {
  static numDecimals = 2;

  all_stats : Array<T_Stats>;
  
  change_culti     : (path: string, next: T_Next) => void;
  center_culti     : (on_map: boolean, on_tree: boolean) => void;
  center_culti_both: () => void;
  menu_culti       : () => void;
  menu_stats       : () => void;
  close_menus      : () => void;
  show_tools       : () => void;
  hide_tools       : () => void;
  select_culti     : () => void;
  stats_diagnostics: () => void;
  start_book       : () => void;
  show_mt_details  : () => void;
  tabla_oport      : () => void;
  // download_tabla   : () => void;
  
  
  
  constructor(props: T_ToolbarProps) {
    super(props);

    const culti = _.maxBy(this.props.cultis, cti => props.app.map_ui.map.Shp_List[cti].old);

    this.state = {
      sel_pol          : null,
      stats            : null,
      stats_recalc     : false,
      culti,
      cod              : takeCod(culti),
      use_tools        : true,
      show_menu_culti  : false,
      show_menu_stats  : false,
      show_select_culti: false,
      show_tabla_oport : false,
      ordered_pairs    : null,
      hay_rasters      : true
    };

    this.all_stats = [];
    
    this.change_culti      = this.change_culti.bind(this);
    this.center_culti      = this.center_culti.bind(this);
    this.center_culti_both = this.center_culti_both.bind(this);
    this.menu_culti        = this.menu_culti.bind(this);
    this.menu_stats        = this.menu_stats.bind(this);
    this.select_culti      = this.select_culti.bind(this);
    this.close_menus       = this.close_menus.bind(this);
    this.show_tools        = this.show_tools.bind(this);
    this.hide_tools        = this.hide_tools.bind(this);
    this.start_book        = this.start_book.bind(this);
    this.stats_diagnostics = this.stats_diagnostics.bind(this);
    this.show_mt_details   = this.show_mt_details.bind(this);
    this.tabla_oport       = this.tabla_oport.bind(this);
    // this.download_tabla    = this.download_tabla.bind(this);

    
    props.app.toolbar = this;
  }



  componentWillUnmount() {
    this.props.app.toolbar = null;
  }



  check_num_rasters = (): void => {
    const {app} = this.props,
          url   = `${app.remote}/num-rasters/?session_id=${app.session()}&path=${takeDir(this.state.culti)}`;

    fetch(url).then(resp => resp.json()).then((num: number) => {
      this.setState({hay_rasters: num > 0});
    });
  };



  componentDidMount() {
    let using_medidas = false;

    if (this.props.app.medidas != null && this.props.app.medidas.state.active) {
      using_medidas = true;
    }

    if (! this.props.app.agrosat_user) {
      this.setState({
        use_tools: (! this.props.app.is_unpub(takeDir(_.last(this.props.cultis)))) && (! using_medidas)
      });
    }
    else {
      this.setState({
        use_tools: ! using_medidas
      });
    }

    this.check_num_rasters();
  }



  componentDidUpdate(prevProps: T_ToolbarProps, prevState: T_ToolbarState) {
    const
      {app} = this.props,
      {map_ui} = app;

    if (this.props.cultis.length !== prevProps.cultis.length) {
      map_ui.change_culti(_.last(this.props.cultis), noop, true, false);
    }
    else if (this.props.current_map != null && this.props.current_map !== prevProps.current_map) {
      this.change_image_stats(this.props.current_map);
    }
    else if (this.props.current_map == null && prevProps.current_map != null && this.state.stats != null) {
      this.setState({stats: null});
    }
    else if (prevState.stats == null && this.state.stats != null) {
      this.setState({ordered_pairs: this.get_ordered_pairs()});
    }

    if (this.props.current_map == null && prevProps.current_map != null && map_ui.state.show_mav) {
      map_ui.setState({show_mav: false}, () => {
        this.props.app.setState({showing_mav: false});
      });
    }

    if (app.state.show_central_fert && this.state.sel_pol != null && ! _.isEqual(this.state.sel_pol, prevState.sel_pol)) {
      if (app.central_fert != null && app.central_fert.state.path === this.state.sel_pol.path) {
        app.central_fert.setState({hilight_id: this.state.sel_pol.id + 1});
      }
    }

    if (this.state.culti !== prevState.culti) {
      this.check_num_rasters();
    }
  }



  equal_stats(s1: T_Stats, s2: T_Stats): boolean {
    if (s1.culti !== s2.culti) {
      return false;
    }

    if (s1.elem !== s2.elem) {
      return false;
    }

    if (s1.png !== s2.png) {
      return false;
    }

    if (s1.tif !== s2.tif) {
      return false;
    }

    return true;
  }



  change_culti = (path: string, next: T_Next = noop): void => {
    const {app} = this.props;

    if (this.state.culti === path) {
      return next(true);
    }

    if (has_low_priority(path, this.props.cultis)) {
      return next(false);
    }

    const cod = takeCod(path);

    if (cod !== T_MAV && this.state.cod === T_MAV && app.map_ui.state.mav_detail) {
      app.map_ui.setState({mav_detail: null});
    }
    else if (cod === T_MAV) {
      const shp = app.map_ui.map.Shp_List[path];

      app.map_ui.setState({
        mav_detail: {
          rows: mav_rows(shp.obj.html_body, shp.obj.dbfRecords),
          path
        }
      });
    }

    const new_state = {
      culti    : path,
      use_tools: true,
      cod,
      stats    : _.cloneDeep(this.state.stats),
      sel_pol  : _.cloneDeep(this.state.sel_pol)
    };

    if (this.state.stats && (path !== this.state.stats.culti || ! _.includes(this.props.cultis, this.state.stats.culti))) {
      new_state.stats   = null;
      new_state.sel_pol = null;
    }

    if (new_state.stats != null && this.state.stats != null && this.equal_stats(new_state.stats, this.state.stats)) {
      delete new_state.stats;
    }

    if (new_state.sel_pol === this.state.sel_pol) {
      delete new_state.sel_pol;
    }

    if (app.is_unpub(takeDir(path)) && ! app.agrosat_user) {
      new_state.use_tools = false;
    }

    const end = () => {
      this.setState(new_state, () => {
        next(true);
      });
      if (app.central_fert != null) {
        app.central_fert.select_culti(path);
      }
    };

    if (app.tree != null) {
      app.tree.hilight_shp(this.state.culti, false, false, end);
    }
    else {
      end();
    }
  }



  change_image_stats(png_path: string, next: T_Next = noop): void {
    if (! png_path) {
      this.setState({stats: null}, () => next(false));
    }
    else {
      const dir      = takeDir(png_path),
            png_file = takeFilename(png_path),
            stats    = _.find(this.all_stats, st => st.png === png_file && takeDir(st.culti) === dir);

      if (stats) {
        this.setState({stats}, () => next(true));
      }
      else {
        next(false);
      }
    }
  }



  decimal_format(): string {
    return `0,0.${_.times(Toolbar.numDecimals, _.constant('0')).join('')}`;
  }



  center_culti = (on_map: boolean, on_tree: boolean): void => {
    const {app} = this.props;

    if (on_map) {
      app.map_ui.map.center_and_zoom_path(this.state.culti, true);
    }

    if (on_tree) {
      if (app.tree != null) {
        const item_shp = app.get_item_shp(this.state.culti);

        if (item_shp != null) {
          item_shp.scroll();
        }
      }
    }

    this.setState({show_menu_culti: false});
  }



  center_culti_both = (): void => {
    this.center_culti(true, true);
  }



  get_ordered_pairs(): Array<{elem: string, png_path: string}> {
    const dir   = takeDir(this.state.culti),
          {app} = this.props;

    const rs = (
      app
        .get_images_of(dir)
        .map(png => png.props.node.File)
        .filter(png_file => png_file.indexOf('Mapa_Tematico_') !== 0)
        .map((png_file) => {
          const st = _.find(this.all_stats, st => st.png === png_file);

          if (st != null) {
            return {elem: st.elem, png_path: `${dir}/${st.png}`};     // elem was png.props.node.label, now is st.elem
          }
          else {
            return {elem: '', png_path: ''};
          }
        })
    );

    return rs.filter(pe => pe.elem !== '');
  }



  stats_diagnostics = (result: boolean): void => {
    const {app} = this.props;

    if (app.agrosat_user && (Role.es_produccion(app.state.user.role) || app.dev_mode)) {
      const {culti} = this.state,
            dir     = takeDir(culti),
            tifs    = this.all_stats.map(st => `${dir}/${st.tif}`),
            fnum    = gen_snum(this.props.num_decimals);

      get_area_extent(app, culti, (res_culti: T_ErrNum) => {
        if (res_culti.error && typeof res_culti.error === 'string') {
          Alert.error(res_culti.error);
        }
        else if (typeof res_culti === 'number') {
          const extent_culti = res_culti;

          mapSeries(tifs, (tif_path: string, callback) => {
            get_area_extent(app, tif_path, (res_tif: T_ErrNum) => {
              if (res_tif.error && typeof res_tif.error === 'string') {
                Alert.error(res_tif.error);
              }
              else if (typeof res_tif === 'number') {
                const extent_tif = res_tif,
                      diff       = Math.abs(extent_culti - extent_tif),
                      tif_file   = takeFilename(tif_path),
                      sdiff      = fnum(diff);

                if (diff > 1000) {
                  Alert.error(
                    `Los extents del cultivable y de ${tif_file} difieren en ${sdiff} m<sup>2</sup>. Revise.`,
                    {html: true, timeout: 10000}
                  );
                }
              }

              callback(null, true);
            });
          });
        }
      });
    }
  }



  toggle_stats = (next: T_Next = noop): void => {
    if (this.state.stats) {
      this.setState({stats: null, show_menu_stats: false, ordered_pairs: null}, () => {
        this.all_stats = [];
      });
    }
    else {
      const {app} = this.props,
            dir   = takeDir(this.state.culti),
            show  = () => show_stats(app, this.state.culti, next),
            imgp  = app.map_ui.map.last_img_path(dir);

      if (imgp !== '' && es_mapa_tematico(imgp)) {
        const item_png = app.get_item_png(imgp);

        if (item_png != null) {
          item_png.close(show);
        }
        else {
          show();
        }
      }
      else {
        show();
      }
    }
  };



  menu_culti = (): void => {
    this.setState({show_menu_culti: true, show_menu_stats: false, show_select_culti: false, show_tabla_oport: false});

    this.props.app.setState({show_menu_user: false, show_config_book: false});
  }



  menu_stats = (): void => {
    this.setState({show_menu_stats: true, show_menu_culti: false, show_select_culti: false, show_tabla_oport: false});

    this.props.app.setState({show_menu_user: false, show_config_book: false});
  }



  select_culti = (): void => {
    this.setState({show_select_culti: true, show_menu_culti: false, show_menu_stats: false, show_tabla_oport: false});

    this.props.app.setState({show_menu_user: false});
  }



  tabla_oport = (): void => {
    if (this.state.show_tabla_oport) {
      this.setState({show_tabla_oport: false })
    } else {
      this.setState({show_tabla_oport: true, show_menu_culti: false, show_menu_stats: false, show_select_culti: false})
    }

    this.props.app.setState({show_menu_user: false});
  }

  

  close_menus = (): void => {
    const new_state = {};

    if (this.state.show_menu_culti) {
      new_state.show_menu_culti = false;
    }

    if (this.state.show_menu_stats) {
      new_state.show_menu_stats = false;
    }

    if (this.state.show_select_culti) {
      new_state.show_select_culti = false;
    }

    if (this.state.show_tabla_oport) {
      new_state.show_tabla_oport = false;
    }

    if (this.state.show_menu_culti || this.state.show_menu_stats || this.state.show_select_culti || this.state.show_tabla_oport) {
      this.setState(new_state);
    }
  }



  show_tools = (): void => {
    this.setState({use_tools: true});
  }



  hide_tools = (): void => {
    this.setState({use_tools: false});
  }



  start_book = (): void => {
    this.props.app.start_book(12, 'near', 'NO', 'NO');
  }



  show_mt_details = (): void => {
    if (this.props.current_map != null && this.props.current_map !== '') {
      const {app} = this.props;

      get_mapatematico_fathers(app, this.props.current_map, (fathers_paths: Array<string>) => {
        if (fathers_paths.length < 2) {
          console.error('El MT tiene menos de dos padres.');
          return;
        }

        const paths = _.cloneDeep(fathers_paths);

        paths.unshift(this.props.current_map);

        app.setState({four_maps: true, symmetric_four_maps: false, review_thematic: true}, () => {
          _.delay(() => {
            if (app.four_maps != null) {
              const {four_maps} = app;

              four_maps.kill_low_image(paths[0], () => {
                four_maps.activate_map(0, () => {
                  const item_png = app.get_item_png(paths[0]);

                  if (item_png != null) {
                    item_png.open(() => {
                      const dirs = _.uniq(_.tail(paths).map(takeDir));

                      if (app.tree != null) {
                        app.tree.open_these(dirs, () => {
                          four_maps.add_low_image(paths[1], () => {
                            four_maps.add_low_image(paths[2], () => {
                              if (paths.length === 4) {
                                four_maps.add_low_image(paths[3], () => {});
                              }
                            });
                          });
                        });
                      }
                    });
                  }
                });
              });
            }
          }, 300);
        });
      });
    }
  }



  show_central_fert = (): void => {
    const {app} = this.props;

    const do_show = () => app.setState({show_central_fert: true});

    app.sidebar.hide_all(true);

    if (! this.state.stats) {
      load_stats(app, this.state.culti, false, false, ! app.agrosat_user, (ss: Array<T_Stats>) => {
        const preamble = (fun = noop): void => {
          fun(true);
        };

        preamble((result: boolean) => {
          if (app.toolbar != null) {
            const {toolbar} = app;
            toolbar.all_stats = ss
          }
        })
      })
      do_show()
      // this.toggle_stats(do_show);
    } else {
      do_show();
    }
  };



  render() {
    const {app, current_map}        = this.props,
          {culti}      = this.state,
          title        = abrev(title_culti(this.state.culti), 30),
          elem         = this.state.stats != null ? this.state.stats.elem  : '',
          units        = this.state.stats != null ? this.state.stats.units : '',
          stats_title  = _.has(this.state.stats, 'elem') ? `Estadísticas ${unFuck(elem)} ${units == null ? '' : ` ${units}`}` : 'Calculando…',
          sty_xstats   = {left: 80},
          es_tematico  = this.props.current_map != null && takeFilename(this.props.current_map).indexOf('Mapa_Tematico_') === 0,
          xfont        = {font: app.favorite_font()},
          shapes       = highest_shps(this.props.cultis),
          is_diff      = current_map !== null ? current_map.includes('diff_') : false,
          is_biosense  = culti.search('biosense') !== -1,
          is_nutrichkf = culti.search('nutricheck_foliar') !== -1,
          is_nutrichks = culti.search('nutricheck_suelo') !== -1,
          is_soilchk   = culti.search('soilcheck') !== -1 || culti.search('adf') !== -1,
          servicio     = is_biosense ? 'biosense' : (is_nutrichkf ? 'nutricheck_foliar' : (is_nutrichks ? 'nutricheck_suelo' : 'soilcheck')),
          user_rol     = app.state.user.id_rol;

    // NOTE: El botón de estadísticas solía usar el ícono table. El informe de predios usaba file-word-o.

    return (
      <div className='toolbar' style={{fontFamily: xfont.font}}>
        <MenuCulti
          culti={this.state.culti}
          cond={this.state.show_menu_culti}
          elem={this.props.current_map == null ? '' : this.props.current_map}
          app={app}
        />

        <MenuStats
          culti={this.state.culti}
          cond={this.state.show_menu_stats}
          agrosat_user={app.agrosat_user}
          showing_stats={this.state.stats != null}
          toolbar={this}
        />

        <SelectCulti
          culti={this.state.culti}
          cond={this.state.show_select_culti}
          shapes={shapes}
          app={app}
        />

        {culti.includes('UPL') && user_rol >= 5 &&
          <XDialog name="show_tabla_oport" title="" father={this} drag={false} no_close={false} font={app.favorite_font()} huge_title={true}>
            <TablaOportUPL
              agrosat_user={app.agrosat_user}
              app={app}
              culti={culti}
              current_map={is_diff ? current_map.replace('.png', '.tif'): ''}
              is_diff={is_diff}
              servicio={servicio}
            />
          </XDialog>
        }

        <ReactTooltip place='right' type='info' effect='solid' id='culti_path'>
          <span>{show_path(this.state.culti)}</span>
        </ReactTooltip>

        {(this.state.cod === T_CULTI && this.state.hay_rasters) &&
          <MapButton
            label='Estadísticas'
            icon='angle-down'
            bgcolor={this.state.stats ? '#8abee5' : 'white'}
            fun={this.menu_stats}
            cond={this.state.use_tools}
            icon_right={true}
            id='bt_stats'
          />
        }

        {(is_diff || is_nutrichkf || is_soilchk) && culti.includes('UPL') && user_rol >= 5 &&
          <MapButton
            label="Tablero de Soluciones"
            fun={this.tabla_oport}
            id="bt_oport"
            />
          }


        {(this.state.stats != null && this.state.ordered_pairs != null) &&
          <XDialog name='stats' title={stats_title} father={this} drag={! this.props.window_drag} style={sty_xstats} {...xfont}>
            <Stats
              stats={this.state.stats}
              sel_pol={this.state.sel_pol}
              num_decimals={this.props.num_decimals}
              show_elems={this.state.ordered_pairs}
              app={app}
            />
          </XDialog>
        }

        {(this.state.stats_recalc && ! this.state.stats) &&
          <div className='stats_wait' style={sty_xstats}>
            <Wait />
          </div>
        }

        {(this.state.cod === T_CULTI && ! es_tematico) &&
          <MapButton
            tip='Informe de servicio'
            icon='angle-down'
            label='Informe'
            fun={app.config_book}
            cond={this.state.use_tools}
            icon_right={true}
            id='bt_informe'
          />
        }

        <MapButton
          label={title}
          tip={this.state.culti}
          idtip='culti_path'
          icon='angle-down'
          fun={this.menu_culti}
          icon_right={true}
          id='bt_culti'
        />

        {(shapes.length > 1) &&
          <MapIcon
            tip='Cultivables'
            icon='ellipsis-v'
            fun={this.select_culti}
            id='bt_select_culti'
            cond={true}
          />
        }

        {(app.agrosat_user && this.props.current_map != null && es_mapa_tematico(this.props.current_map)) &&
          <MapButton
            label='Detalles del MT'
            icon='info'
            fun={this.show_mt_details}
            icon_right={true}
          />
        }
        
        {/* {(! es_tematico) &&
          <MapButton
            label='Central de Fertilización'
            fun={this.show_central_fert}
            />
        } */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Toolbar.jsx